import React from 'react';
import AdvanceRow from 'features/requirements/components/advanceForm/AdvanceRow';
import ActualAdvanceSettingDTO from 'features/requirements/dtos/ActualAdvanceSettingDTO';
import PageCard from 'features/shared/components/card/PageCard';
import AdvanceRowHeader from 'features/requirements/components/advanceForm/AdvanceRowHeader';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { AdvanceFormSection_PageCard } from 'features/shared/components/loaders/promiseLoadingAreas';
import { useTranslation } from 'react-i18next';

interface Props {
  bindField: any;
  actualAdvances: ActualAdvanceSettingDTO[];
  editable: boolean;
  errors?: Record<string, string>;
}

const AdvancesSubForm = ({ actualAdvances, editable, bindField, errors }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // helpers
  const getError = (orderOfDueDate: number): string | undefined => {
    if (errors) {
      let inputName = `DESC_TMzalohyNovaVyse${orderOfDueDate}`;
      return errors[inputName] ?? undefined;  
    }
  }

  // sub-renders
  const renderAdvancesRows = () => {
    const count = actualAdvances.length;

    return actualAdvances.map((item, index) =>
      <div className="py-1" key={index}>
        <AdvanceRow 
          advanceSetting={item}
          bindField={bindField}
          error={getError(item.orderOfDueDate!)}
        />
        {renderDivider(count, index)}
      </div>
    )
  }

  const renderDivider = (count: number, index: number) => {
    if (index < count - 1) {
      return <hr className="d-sm-none mb-2"/>;
    }
  }

  // render
  if (editable) {
    return (
      <PageCard 
        title={tLabels("advancesSubForm.cardTitle")}
        bodyClassName="p-4"
        loadingAreaName={AdvanceFormSection_PageCard}
      >
        <NoContentWrapper 
          data={actualAdvances}
          loadStatus="AfterFirstLoad"
          noContentRender={() => <div className="text-muted">{tLabels("advancesSubForm.noAdvanceForSet")}</div>}
        >
          <AdvanceRowHeader />
          {renderAdvancesRows()}
        </NoContentWrapper>
      </PageCard>
    );  
  } else {
    return null;
  }
}

export default AdvancesSubForm;
